//FireBase
exports.firebaseConfig = {
  apiKey: "AIzaSyDfLNcyyc829onlo0FAVnzg_d-jwZ2ydOE",
  authDomain: "sjaloom-connect.firebaseapp.com",
  databaseURL: "https://sjaloom-connect.firebaseio.com",
  projectId: "sjaloom-connect",
  storageBucket: "sjaloom-connect.appspot.com",
  messagingSenderId: "870293399813"
};

exports.firebaseDebugConfig = {
  apiKey: "AIzaSyAQ87jkoqPMzMNpzUpLQvDhVOeaT7nKNs8",
  authDomain: "sjaloom-connect-debug.firebaseapp.com",
  databaseURL: "https://sjaloom-connect-debug.firebaseio.com",
  projectId: "sjaloom-connect-debug",
  storageBucket: "sjaloom-connect-debug.appspot.com",
  messagingSenderId: "834035417478"
};


//App setup
exports.adminConfig={
  "appName": " Sjaloom Connect Admin",
  "year": new Date().getFullYear(),
  "develop": false,
  "slogan":"Stay connected",
  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"green", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"black", // "white | black"
  },
  "showItemIDs":false,
  "allowedUsers":["app@sjaloomheerhugowaard.nl","bmpieterman@aim.com"], //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":false, //Allowed users must contain list of allowed users in order to use google auth
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":["-event"],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":true,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"YOUR_KEY",

  "fieldsTypes":{
    "photo":["photo","image","leaderImage"],
    "dateTime":["end","start","birthday"],
    // "date":["end","start","birthday"],
    "input":["title"],
    "map":["map","latlng","location"],
    "textarea":["description"],
    "html":["content"],
    "radio":["radio","radiotf","featured","active"],
    "checkbox":["checkbox"],
    "dropdowns":["status","dropdowns"],
    "file":["video"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['type','creator','group'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
    "iconio":['iconio']
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD", "timeFormat":false, "saveAs":"YYYY-MM-DD", "locale":"nl"},
    {"key":"start", "dateFormat":"YYYY-MM-DD", "timeFormat":false, "saveAs":"YYYY-MM-DD", "locale":"nl"},
    {"key":"birthday", "dateFormat":"YYYY-MM-DD", "timeFormat":false, "saveAs":"YYYY-MM-DD", "locale":"nl"},
  ],
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"status","options":["just_created","confirmed","canceled"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"featured","options":["true","false"]},
      {"key":"active","options":["true","false"]}
  ],
  "optionsForRelation":[
      {
        //Firestore - Native
        "display": "name",
        "key": "group",
        "path": "/groups",
        "value": "name",
        "isValuePath": true,
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
      },
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 20,
    "finite": true,
    "retainLastPage": false
  },
  "hiddenKeys":["keyToHide","anotherKeyToHide","email"],
  "previewOnlyKeys":["previewOnlyKey","anotherPreviewOnlyKye","name","created_or_edited"]
}

//Navigation
exports.navigation=[
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"home",
      "path": "",
       isIndex:true,
    },
    {
      "link": "storage",
      "path": "",
      "name": "Media",
      "icon": "photo_library",
    },
    {
      "link": "firestoreadmin",
      "path": "announcements",
      "name": "Mededelingen",
      "icon":"list_alt",
      "tableFields":["title","active"]
    },
    {
      "link": "firestoreadmin",
      "path": "groups",
      "name": "Groepen",
      "icon":"library_books",
      "tableFields":["name","registerCode"],
    },
    {
      "link": "firestoreadmin",
      "path": "leaders",
      "name": "Leiders",
      "icon": "people_outline",
      "tableFields": ["name","leaderImage","function"],
    },
    // {
    //   "link": "firestoreadmin",
    //   "path": "users",
    //   "name": "Gebruikers",
    //   "icon": "group",
    //   "tableFields":["firstName","lastName","role"],
    // }, 
    // {
    //   "link": "firestoreadmin",
    //   "path": "user/{useruuid}",
    //   "name": "Mijn Profiel",
    //   "icon": "perm_identity",
    //   "tableFields":["name"],
    // },
    // {
    //   "link": "link",
    //   "path": "http://mobidonia.com",
    //   "name": "Mobidonia.com",
    //   "icon": "web",
    //   "tableFields":["name"],
    // },
    {
      "link": "push",
      "path": "",
      "name": "Push notificaties",
      "icon":"speaker_notes",
      "tableFields":[],
    }
  ];
 
  //From v 5.1.0 we suggest remoteSetup due to security
  //
exports.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"onesignal", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyCFUf7fspu61J9YsWE-2A-vI9of1ihtSiE", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"NjAxMzM2MzktZjIyNy00YWNhLTlkZTgtMGRmZTI2ZGRiYzhk",
  "oneSignal_APP_KEY":"11637c29-616e-4998-a63e-602bf4c250ec",
  "included_segments":"Subscribed Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":false, //Should we store the notification in firestore
}

exports.userDetails={

}

exports.remoteSetup=false;
exports.remotePath="admins/mobidonia";
exports.allowSubDomainControl=false;
exports.subDomainControlHolder="admins/";


// WEBPACK FOOTER //
// ./src/config/app.js